var host = document.location.hostname;
if(host == "localhost" || host == "192.168.1.110") {
	BackendUrl = 'http://' + document.location.hostname + ':29188/';
} else {
	BackendUrl = 'https://gameadapi.hivelancetech.com/';
}
ApiUrl = 'http://'+document.location.hostname+':2083/';
export var BackendUrl;
export var ApiUrl;